/* unplugin-vue-components disabled */import script from "./RecruitmentStageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentStageCard.vue?vue&type=script&setup=true&lang=js"

import "./RecruitmentStageCard.vue?vue&type=style&index=0&id=329a8b5b&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329a8b5b"]])

export default __exports__